import React from "react";
import { PaymentAdsContent, PaymentContent, PaymentPageFactory } from "../..";
import { NoDataComponent } from "../../../../../../ds";
import { PaymentAdsSubscriptionResponse, PaymentSubscriptionResponse, SubscriptionChosen } from "../../../../business/core";

export class PaymentPageFactoryImpl implements PaymentPageFactory {
    create(paymentData: PaymentSubscriptionResponse | null, originalData: SubscriptionChosen, isToUpdate?: boolean): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        if (!paymentData?.success) return <NoDataComponent />;
        return <PaymentContent paymentData={paymentData.response} subscriptionChosen={originalData} isToUpdate={isToUpdate} />
    }
    createAds(paymentData: PaymentAdsSubscriptionResponse | null, originalData: SubscriptionChosen): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        if (!paymentData?.success) return <NoDataComponent />;
        return <PaymentAdsContent paymentData={paymentData.response} subscriptionChosen={originalData} />
    }
}